import { lazy } from "react"
import { PermissionProtectedRoute } from "~/router/outlets/PermissionProtectedRoute"
import type { OysterRouter } from "~/router/type"
import { LazyLoadingSuspenseWithErrorBoundary } from "@oysterhr/feature-components"

const BASE_URL = "preferences"

const CompanyPreferencesPage = lazy(() => import("./pages/CompanyPreferencesPage"))
const CreateHiringTemplatePage = lazy(() => import("./pages/CreateHiringTemplatePage"))
const HiringTemplateDetailsPage = lazy(() => import("./pages/HiringTemplatesDetailsPage"))
const UpdateHiringTemplatePage = lazy(() => import("./pages/UpdateHiringTemplatePage"))

export const companyHiringTemplateRoutes: OysterRouter = {
  DeprecatedLeftSidebar: [
    {
      path: BASE_URL,
      children: [
        {
          index: true,
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <PermissionProtectedRoute permissions={["company_preferences"]}>
                <CompanyPreferencesPage />
              </PermissionProtectedRoute>
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
      ],
    },
  ],
  DeprecatedFullScreen: [
    {
      path: `${BASE_URL}/templates`,
      children: [
        {
          path: "new",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <CreateHiringTemplatePage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
        {
          path: ":templateId/draft",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <CreateHiringTemplatePage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
        {
          path: ":templateId/details",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <HiringTemplateDetailsPage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
        {
          path: ":templateId/edit/:stepName",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <UpdateHiringTemplatePage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
      ],
    },
  ],
}
